import type { VpIconName } from '@vtmn-play/react'
import type { QuickSearchCategoryView } from './quickSearchRoutes'
import type { Labels } from '@/types/treeViewTypes'
import { useTranslation } from 'react-i18next'

export const SECTION_ICONS: Record<QuickSearchCategoryView, VpIconName> = {
  subdepartments: 'function-tiles',
  families: 'function-tiles',
  supermodels: 't-shirt-number',
  models: 't-shirt',
}

export function getQuickSearchResultLabel(labels: Labels, locale: string): string {
  const language = locale.split('-')[0]

  if (language === 'fr') {
    return labels.fr || labels.en
  }

  return labels.en || labels.fr
}

export function useQuickSearchLabels() {
  const { t } = useTranslation()

  return {
    CHIP_LABELS: {
      subdepartments: t('quick-search.category-subdepartments'),
      families: t('quick-search.category-families'),
      supermodels: t('quick-search.category-supermodels'),
      models: t('quick-search.category-models'),
    } as Record<QuickSearchCategoryView, string>,
    SECTION_TITLES: {
      subdepartments: t('quick-search.category-subdepartments'),
      families: t('quick-search.category-families'),
      supermodels: t('quick-search.category-supermodels'),
      models: t('quick-search.category-models'),
    } as Record<QuickSearchCategoryView, string>,
    SECTION_ICONS,
  }
}
